import React, { useState, useEffect } from 'react';
import '../../screen/Catalog/style.css';

const PRODUCTS = [
    { key: 'company',     label: '회사',         emoji: '🏢', color: '#01BCD6' },
    { key: 'antstalk',    label: 'AntsTalk',     emoji: '💬', color: '#ec4899' },
    { key: 'antsmeeting', label: 'AntsMeeting',  emoji: '📹', color: '#f97316' },
    { key: 'nodemaster',  label: 'NodeMaster',   emoji: '🧠', color: '#a78bfa' },
    { key: 'ganttchart',  label: 'GanttChart',   emoji: '📅', color: '#34d399' },
    { key: 'antsmusic',   label: 'AntsMusic',    emoji: '🎵', color: '#8b5cf6' },
    { key: 'skyscribe',   label: 'SkyScribe',    emoji: '🎵', color: '#60a5fa' },
    { key: 'story',       label: 'Story',        emoji: '📖', color: '#94a3b8' },
    { key: 'skynet',      label: 'Skynet',       emoji: '🤖', color: '#22c55e' },
    { key: 'estimate',    label: 'Estimate',     emoji: '💰', color: '#f43f5e' },
    { key: 'store',       label: '서비스마켓',   emoji: '🛒', color: '#10b981' },
    { key: 'ar',          label: 'AR대탈출',     emoji: '🎯', color: '#a855f7' },
    { key: 'minigrow',    label: '미니그로우',   emoji: '🌱', color: '#84cc16' },
    { key: 'malbok',      label: 'AI Agent (말복)', emoji: '🤖', color: '#0ea5e9' },
    { key: 'meta',        label: '메타월드',     emoji: '🎮', color: '#fbbf24' },
];

const ASSET_LABELS = {
    ci: '회사 CI', flyer: '전단지 (A4)', brochure: '팜플렛',
    catalog: '카탈로그', poster: '포스터 (B2)', card: '명함',
    logo: '로고', etc: '기타',
};
const ASSET_ICONS = {
    ci: '🎨', flyer: '📄', brochure: '📂', catalog: '📚',
    poster: '🖼️', card: '🪪', logo: '⭐', etc: '📎',
};
const SIDE_LABEL = { front: '앞면', back: '뒷면' };

function formatSize(bytes) {
    if (!bytes) return '';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

export default function CatalogPanel() {
    const [items, setItems] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('all');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/api/catalog')
            .then(res => res.json())
            .then(data => { if (data.success) setItems(data.items || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const filtered = selectedProduct === 'all'
        ? items
        : items.filter(it => it.product_key === selectedProduct);

    const grouped = {};
    for (const it of filtered) {
        if (!grouped[it.product_key]) grouped[it.product_key] = [];
        grouped[it.product_key].push(it);
    }

    const counts = {};
    for (const it of items) counts[it.product_key] = (counts[it.product_key] || 0) + 1;

    if (loading) return <div className="CatalogEmpty">로드 중...</div>;
    if (items.length === 0) {
        return (
            <div className="CatalogEmpty">
                <div style={{ fontSize: '3rem', marginBottom: 16 }}>📭</div>
                아직 공개된 자료가 없습니다.
            </div>
        );
    }

    return (
        <>
            <div className="CatalogFilterBar">
                <button
                    type="button"
                    onClick={() => setSelectedProduct('all')}
                    className={'CatalogPill' + (selectedProduct === 'all' ? ' active' : '')}
                    style={{ '--pill-color': '#01BCD6' }}
                >전체 <span className="cnt">{items.length}</span></button>
                {PRODUCTS.map(p => {
                    const c = counts[p.key] || 0;
                    if (c === 0) return null;
                    return (
                        <button
                            key={p.key}
                            type="button"
                            onClick={() => setSelectedProduct(p.key)}
                            className={'CatalogPill' + (selectedProduct === p.key ? ' active' : '')}
                            style={{ '--pill-color': p.color }}
                        >
                            {p.emoji} {p.label} <span className="cnt">{c}</span>
                        </button>
                    );
                })}
            </div>

            {Object.keys(grouped).sort((a, b) =>
                PRODUCTS.findIndex(p => p.key === a) - PRODUCTS.findIndex(p => p.key === b)
            ).map(productKey => {
                const info = PRODUCTS.find(p => p.key === productKey) || { label: productKey, emoji: '📦', color: '#94a3b8' };
                return (
                    <section key={productKey} className="CatalogProductSection">
                        <div className="CatalogProductHead" style={{ '--p-color': info.color }}>
                            <span className="CatalogProductBadge">
                                <span className="emoji">{info.emoji}</span>
                                <span className="name">{info.label}</span>
                            </span>
                            <span className="count">{grouped[productKey].length}건</span>
                        </div>
                        <div className="CatalogCardGrid">
                            {grouped[productKey].map(it => {
                                const aspectKey = it.asset_type in ASSET_LABELS ? it.asset_type : 'etc';
                                const thumb = it.thumbnail_url || (it.file_url && /\.(png|jpe?g|gif|webp|svg)$/i.test(it.file_url) ? it.file_url : null);
                                return (
                                    <a
                                        key={it.id}
                                        href={it.file_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="CatalogCard"
                                        style={{ '--p-color': info.color }}
                                    >
                                        <div className="CatalogThumb" data-aspect={aspectKey}>
                                            {thumb ? (
                                                <img src={thumb} alt={it.label} loading="lazy" />
                                            ) : (
                                                <div className="CatalogThumbEmpty">
                                                    <span className="emoji">{ASSET_ICONS[it.asset_type] || '📎'}</span>
                                                    <span className="text">이미지를 준비 중입니다</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="CatalogCardBody">
                                            <div className="CatalogCardTop">
                                                <span className="asset-icon">{ASSET_ICONS[it.asset_type] || '📎'}</span>
                                                <span className="asset-badge">
                                                    {ASSET_LABELS[it.asset_type] || it.asset_type}
                                                    {it.side && ` · ${SIDE_LABEL[it.side]}`}
                                                </span>
                                            </div>
                                            <div className="CatalogCardLabel">{it.label}</div>
                                            <div className="CatalogCardFoot">
                                                <span className="size">{formatSize(it.file_size)}</span>
                                                <span className="dl">⬇ 다운로드</span>
                                            </div>
                                        </div>
                                    </a>
                                );
                            })}
                        </div>
                    </section>
                );
            })}
        </>
    );
}
